import TransactionListing from './TransactionListing';

export default TransactionListing;
